import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"icon-money\"><defs><style>#icon-money .cls-1{fill:#242424;}</style></defs><path class=\"cls-1\" d=\"M100,35a65,65,0,1,0,65,65A65,65,0,0,0,100,35Zm23.62,74.62a7,7,0,0,1,0,14H107v7.83a7,7,0,0,1-14,0v-7.83H76.38a7,7,0,0,1,0-14H93v-5H76.38a7,7,0,0,1,0-14h12l-13-18a7,7,0,0,1,11.35-8.2l13.3,18.41,13.17-18.39a7,7,0,0,1,11.38,8.16l-12.9,18h11.91a7,7,0,0,1,0,14H107v5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol